module.exports = __webpack_public_path__ + "img/lumesia-logo.8d7e0a21.png";